import PropTypes from 'prop-types';

import { IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN } from 'constants/theme';

export function Rescued({ brand, isActive, width }) {
    const handColor = brand === MISFITS_THEME_DOMAIN ? '#F2EBD1' : '#F8E1A4';
    const activeColor = brand === MISFITS_THEME_DOMAIN ? '#D7E1B8' : '#F0D3E3';
    const pepperColor = brand === MISFITS_THEME_DOMAIN ? '#2E8540' : '#547420';
    const pepperStemColor = brand === MISFITS_THEME_DOMAIN ? '#B0C472' : '#C5DB66';

    return (
        <svg width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            {isActive && (
                <path
                    d="M14.6505 28.7652C21.902 26.9646 29 22.6358 29 14.9992C29 7.3625 22.9452 2.7363 14.6505 1.1728C7.31233 -0.213857 2.48978 6.96057 1.13553 14.967C-0.132106 22.475 7.73356 30.4815 14.6505 28.7652Z"
                    fill={activeColor}
                />
            )}
            <path
                d="M16.8094 7.21902C17.0665 7.59997 17.5618 7.82855 17.9999 7.70474C18.038 8.29521 18.5427 8.79045 19.1237 8.91426C19.7046 9.03807 20.3141 8.82855 20.7618 8.44759C21.0665 8.19045 21.2951 7.85712 21.476 7.49521C21.4284 7.50474 21.3808 7.50474 21.3332 7.52378C21.0951 7.22855 20.8189 6.99045 20.5141 6.79045C20.3808 6.22855 20.4475 5.6095 20.7237 5.13331C21.1713 4.36188 21.7141 4.56188 22.4189 4.46664C22.5999 4.43807 22.7427 4.31426 22.7618 4.15236C22.8094 3.89521 22.9046 3.49521 22.9808 3.22855C23.0284 3.05712 22.9427 2.86664 22.7618 2.76188C22.476 2.59997 22.1903 2.46664 21.9141 2.38093C20.8379 2.04759 19.8189 2.29521 18.9618 3.08569C18.3522 3.64759 17.9522 4.29521 17.4475 4.91426C17.2475 5.15236 17.0475 5.29521 16.8284 5.4095C16.7999 5.36188 16.7713 5.31426 16.7427 5.26664C16.6665 5.47617 16.6094 5.67617 16.5713 5.89521C16.4951 6.34283 16.5522 6.83807 16.8094 7.2095V7.21902Z"
                fill={pepperStemColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.619 9.95238C24.9904 8.77143 23.0571 7 21.4666 7.47619C21.2857 7.83809 21.0571 8.17143 20.7523 8.42857C20.3047 8.80952 19.6857 9.01905 19.1142 8.89524C18.5428 8.77143 18.038 8.27619 17.9904 7.68571C17.5523 7.81905 17.0571 7.58095 16.7999 7.2C16.5428 6.81905 16.4952 6.33333 16.5619 5.88571C16.5999 5.66666 16.6571 5.46666 16.7333 5.25714C16.2285 4.40952 15.1142 3.81905 14.0761 3.49524C14.019 3.47619 13.9619 3.45714 13.9142 3.44762C9.40947 2.17143 7.1428 7.07619 6.3809 10.0762C5.9428 11.8286 6.59042 13.5905 7.04756 15.3619C7.83804 18.3905 7.49518 21.6286 10.9428 23.5048C12.2095 24.2 13.7142 24.5619 14.819 23.6857C18.3238 26.6095 22.0666 22.9429 23.619 20.5048C24.6857 18.8286 25.3523 16.9238 25.9047 15.0381C26.3809 13.4 26.4952 11.619 25.6095 9.9619L25.619 9.95238Z"
                fill={pepperColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.5 21.2165C19.65 20.9065 20.04 20.3565 19.92 19.7765C19.82 19.3165 19.31 19.0965 18.86 18.9465C16.88 18.2665 14.88 17.5865 12.8 17.2965C10.72 17.0065 9.12 17.2565 7.22 18.1365C5.32 19.0165 3.38 21.7165 3 23.7765C4.5 25.0265 5.8 25.8165 7.61 26.5465C8.11 26.7465 8.67 26.9265 9.16 26.7065C9.48 26.5665 9.71 26.2665 10 26.0565C10.97 25.3265 12.29 24.6965 13.47 24.9565C15.19 25.3365 17.58 25.3365 19.28 24.8665C22.21 24.0465 23.65 22.5365 25.39 20.0465C25.66 19.6665 25.94 19.2065 25.82 18.7565C25.65 18.1365 24.78 17.9665 24.2 18.2465C23.62 18.5265 23.24 19.0965 22.81 19.5765C20.77 21.8565 18.51 21.2165 18.51 21.2165H18.5Z"
                fill={handColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3501 20.5065C15.1601 20.8365 16.4901 21.5265 18.5001 21.2165"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

Rescued.propTypes = {
    brand: PropTypes.oneOf([IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN]).isRequired,
    isActive: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Rescued.defaultProps = {
    isActive: false,
    width: 30,
};
